$(document).on('click', '.ftp-row-toggle', function() {
  var target = $($(this).attr('data-target'));
  if (target.is(':visible')) {
    target.slideUp();
    $(this).text('Show line item details');
  } else {
    target.slideDown();
    $(this).text('Hide line item details');
  }
});
